import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

export function useRelevanceAlgo() {
  const experiments = useExperiments()

  const isNewRelevanceAlgoEnabled =
    experiments['experiment.reviewRelevanceAlgorithm'] === 'relevanceV2'

  const orderBy: '-relevance' | '-relevance_alt' = isNewRelevanceAlgoEnabled
    ? '-relevance_alt'
    : '-relevance'

  return {
    orderBy,
    isNewRelevanceAlgoEnabled,
  }
}
